<div class="container">
  @if (!afterShopClick) {
    <pdq-card color="white" variant="popover">
      <div class="card__header">
        <p>Select your store to continue</p>
        <img src="/assets/images/pdq_logo_new.svg" />
      </div>
      <pdq-divider></pdq-divider>
      <div class="card__content">
        @for (shop of userShops; track shop; let i = $index) {
          <div>
            <div (click)="onShopClick(shop.id)" class="shop-item">
              <pdq-avatar
                size="large"
                [imageUrl]="getShopLogoUrl(shop?.id)"
                fallbackImageUrl="assets/images/shop-img.svg"></pdq-avatar>
              <p>{{ shop.title }}</p>
            </div>
            <pdq-divider></pdq-divider>
          </div>
        }
        <footer>
          By selecting a store, PrettyDamnQuick will authenticate your account with an external application.
        </footer>
      </div>
    </pdq-card>
  }
</div>
